<template>
  <v-snackbar v-model="show" :timeout="timeout" :color="color">
    <a v-if="href" :href="href" target="_blank" @click="hide">{{message}}</a>
    <template v-else>
      {{message}}
    </template>
    <v-btn flat color="accent" @click.native="hide" :timeout="0">Close</v-btn>
  </v-snackbar>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    show: {
      get () {
        return this.$store.state.snackbar.show
      },
      set (value) {
        this.$store.commit('snackbar/setShow', value)
      }
    },
    timeout () {
      return this.$store.state.snackbar.timeout
    },
    ...mapState('snackbar', ['message', 'href', 'color'])
  },
  methods: {
    hide () {
      this.$store.commit('snackbar/hide')
    }
  }
}
</script>

// <style lang="scss">
@import "../../assets/css/colors.scss";
.v-snack .error {
  background-color: $color-error;
}
</style>



// WEBPACK FOOTER //
// SnackBar.vue?24cdd3a0